// component used when dynamic import fails
const EpiEmptyComponent = () => {
    return null;
};

export default EpiEmptyComponent;
